import React, { useContext } from "react";

import RemixBuilderSettingsSections from "./shared/RemixBuilderSettingsSections";
import RemixBuilderSettingsLayouts from "./shared/RemixBuilderSettingsLayouts";
import RemixBuilderSettingsTheme from "./shared/RemixBuilderSettingsTheme";
import RemixBuilderSettingsBreadcrumb from "./shared/RemixBuilderSettingsBreadcrumb";
import RemixBuilderPreview from "./shared/RemixBuilderPreview";
import RemixBuilderSettingsDetails from "./shared/RemixBuilderSettingsDetails";

import { RemixBuilderContext } from "./shared/RemixBuilderContext";

const CtaRemixBuilder = ({ rightColumnClassName = "" }) => {
  const [contextData] = useContext(RemixBuilderContext);
  let options;

  if (contextData.from_scratch === true) {
    options = [
      {
        step: 2,
        name: "Content",
      },
      {
        step: 3,
        name: "Theme",
      },
      {
        step: 4,
        name: "Details",
      },
    ]
  } else {
    options = [
      {
        step: 1,
        name: "Sections",
      },
      {
        step: 2,
        name: "Content",
      },
      {
        step: 3,
        name: "Theme",
      },
      {
        step: 4,
        name: "Details",
      },
    ]
  }

  return (
    <>
      <div className="flex-1 flex flex-column justify-between min-w-0">
        <RemixBuilderPreview />
      </div>

      <div className={`w-[400px] shrink-0 flex flex-column justify-between min-w-0 ${rightColumnClassName}`}>
        <RemixBuilderSettingsBreadcrumb options={options} appendLabel="Generate" />
        {contextData.current_step === 1 && <RemixBuilderSettingsSections />}
        {contextData.current_step === 2 && <RemixBuilderSettingsLayouts />}
        {contextData.current_step === 3 && <RemixBuilderSettingsTheme />}
        {contextData.current_step === 4 && <RemixBuilderSettingsDetails remix_type="cta" />}
      </div>
    </>
  );
};

export default CtaRemixBuilder;
